import { Rocket, Target, BarChart, Users, Shield, Zap } from 'lucide-react';

export const features = [
  {
    icon: Rocket,
    title: "Szybki start",
    description: "Rozpocznij transformację swojej szkoły językowej już dziś z naszymi sprawdzonymi strategiami"
  },
  {
    icon: Target,
    title: "Precyzyjne cele",
    description: "Ustal jasne cele rozwoju i systematycznie realizuj plan działania"
  },
  {
    icon: BarChart,
    title: "Wzrost przychodów",
    description: "Zwiększ przychody swojej szkoły dzięki efektywnym metodom sprzedaży"
  },
  {
    icon: Users,
    title: "Zarządzanie zespołem",
    description: "Buduj efektywny zespół i twórz kulturę ciągłego rozwoju"
  },
  {
    icon: Shield,
    title: "Stabilny biznes",
    description: "Zabezpiecz przyszłość swojej szkoły i zbuduj trwałą przewagę konkurencyjną"
  },
  {
    icon: Zap,
    title: "Automatyzacja",
    description: "Zautomatyzuj procesy i skup się na strategicznym rozwoju biznesu"
  }
] as const;